const normalizeQuoteType = (quoteType) =>
  String(quoteType || 'Sales').trim().toLowerCase() === 'rental' ? 'Rental' : 'Sales';

/**
 * Build the default terms for a quote from the selected firm's profile.
 * The returned array intentionally contains no numbering; callers can render
 * it as a bullet list and quotes can still save an exact editable snapshot.
 */
export const buildQuoteTerms = (firm, quoteType) => {
  if (!firm) return [];

  const commonTerms = [
    `Kindly issue a formal Work Order in the name of ${firm.name || ''}, ${firm.address || ''}, GSTIN - ${firm.gstin || ''}, with acceptance of this quotation.`,
    'Loading & Unloading/Movement and shifting of material at the site is in your scope only.',
    `Transportation charges extra at actuals. (Delivery from ${firm.deliveryFrom || ''}).`,
  ];

  if (normalizeQuoteType(quoteType) === 'Rental') {
    return [
      ...commonTerms,
      "Payment terms: 2 months' payment in advance along with the work order.",
      'Delivery of the material within 2-3 working days against payment and work order.',
      'Rental agreement to be sealed and signed from your end.',
      'Undated security cheque of 80% of the material cost.',
      'Please provide the Aadhaar card or valid ID of the authorized signatory.',
    ];
  }

  return [
    ...commonTerms,
    'Payment terms: 100% advance along with the purchase order.',
    'Delivery of the material in 4-5 days against payment and purchase order.',
  ];
};

export const termsToText = (terms) => (Array.isArray(terms) ? terms : []).join('\n');

